import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { Title as TitleBase } from 'components/misc'
import { Thread } from 'styles/misc'

export const Title = styled(TitleBase)`
  ${mq.smallOnly} {
    width: 100% !important;
    margin-top: 6rem;
    margin-left: 0;
    margin-right: auto;
    &::before {
      ${Thread}
      left: 0;
      left: -7.15%;
      top: -36vw;
      width: 114.29%;
      height: auto;
      aspect-ratio: 390 / 215;
      clip-path: none;
      mask-image: url("data:image/svg+xml,%3Csvg width='390' height='215' viewBox='0 0 390 215' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-41.6759 155.068C-20.5277 122.226 12.0979 96.9781 49.1518 84.7828C53.0697 83.4927 57.1778 82.3329 61.2661 82.8775C65.3548 83.4238 69.4303 86.1002 70.387 90.1225C71.3874 94.3305 68.8677 98.4679 66.6741 102.189C63.4045 107.734 60.629 113.574 58.3928 119.612C57.4928 122.043 56.6861 124.792 57.7337 127.165C59.6048 131.402 65.5477 131.354 70.0857 130.489C115.531 121.834 158.378 100.358 204.523 97.0504C215.274 96.2797 228.797 98.3671 232.089 108.66C234.212 115.298 230.864 122.275 229.371 129.082C227.878 135.889 229.853 145.045 236.707 146.225C239.205 146.654 241.733 145.845 244.126 145.015C297.835 126.402 345.989 92.4489 401.447 80.0008' stroke='black' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
    }
  }
`
export const Svg = styled.svg`
  display: block;
  //margin: 0 calc(-1 * var(--container-spacing));
  margin: 0 auto;
  overflow: visible;
  max-width: 39rem;

  ${mq.medium} {
    max-width: 62.2rem;
    margin: 0 auto;
  }
`

export const Caption = styled.div`
  position: relative;
  margin: 3.5rem 0 -8.4rem;
  font-size: 1.2rem;
  text-align: center;
  z-index: 1;
  ${mq.smallOnly} {
    * {
      line-height: 1.5;
    }
  }
  a {
    color: inherit;
    background: transparent;
    text-decoration: underline;
  }

  span {
    content: '';
    display: block;
    width: 1.6em;
    height: 1.6em;
    margin: 2rem auto 0;
    border-radius: 50%;
    flex-shrink: 0;
    opacity: 0.75;
    background-color: var(--background-color);
  }
  ${mq.medium} {
    font-size: 1.4rem;
    margin: 4rem 0 -13rem;
  }
`
